interface UserBadgeProps {
  country: string;
  countryCode: string;
  flag: string;
  isPremium?: boolean;
  duration: number;
}

const UserBadge = ({ country, flag, isPremium, duration }: UserBadgeProps) => {
  const mins = Math.floor(duration / 60);
  const secs = duration % 60;

  return (
    <div className="flex items-center gap-2 flex-wrap">
      {/* Location */}
      <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-black/50 backdrop-blur-md border border-white/10 text-white/80 text-xs">
        <span className="text-base leading-none">{flag}</span>
        <span>{country}</span>
      </div>
      {/* Duration */}
      <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-black/50 backdrop-blur-md border border-white/10 text-white/60 text-xs font-mono">
        <i className="ri-time-line text-white/40" />
        {String(mins).padStart(2, '0')}:{String(secs).padStart(2, '0')}
      </div>
      {/* Premium badge */}
      {isPremium && (
        <div className="flex items-center gap-1 px-2.5 py-1.5 rounded-full bg-yellow-500/20 border border-yellow-500/30 text-yellow-400 text-xs">
          <i className="ri-vip-crown-line text-xs" />
          Premium
        </div>
      )}
    </div>
  );
};

export default UserBadge;
